import { HeaderFromPage } from "../../components/common/HeaderFormPage";
import styles from "./Logout.module.scss";
import { useEffect } from 'react';

export const Logout = () => {
  // Remove all tokens and login creds
  localStorage.clear()

    useEffect(() => {
        setTimeout(() => {
            window.location.href = '/login'
        }, 5000);
    }, []);

  return (
    <div className={styles.wrapper}>
      <HeaderFromPage title='HAVE A NICE DAY' subtitle='You have been logged out' />
      <p className={styles.text}>
        You're logged out of your account.&nbsp;
        <strong>
          <a className={styles.link} href='/login'>
            Click here
          </a>
        </strong>
        &nbsp; to return to the login page or close the tab.
      </p>
    </div>
  );
};
